import {ChangeDetectionStrategy, Component, computed, effect, HostBinding, input} from '@angular/core';

import {Rating} from '@core/interfaces/generated/graphql';
import {ExistsPipe} from '@core/pipes/exists.pipe';
import {StarSolidIconComponent} from '@core/svg-icons/star-solid-icon.component';
import {StarEmptyIconComponent} from '@core/svg-icons/star-empty-icon.component';

type Star = { isSolid: boolean; index: number };
@Component({
  selector: 'app-product-compact-rating-points',
  templateUrl: './product-compact-rating-points.component.html',
  styleUrls: ['./product-compact-rating-points.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ExistsPipe, StarSolidIconComponent, StarEmptyIconComponent]
})

export class ProductCompactRatingPointsComponent {

  rating = input.required<Rating>();
  showEmptyStars = input<boolean>(false);
  stars = computed(() => {
    let stars: Star[] = [];
    if (Number(this.rating().rating) < 0 || Number(this.rating().starCount) < 1){
      return stars;
    }
    let i = 0;
    let i2 = 0;

    while (i < Number(this.rating().rating)) {
      stars.push({isSolid: true, index: i});
      i++;
    }
    while (i2 < this.emptyStarsCount()) {
      stars.push({isSolid: false, index: i});
      i2++;
    }
    return stars;
  });

  emptyStarsCount = computed(() => {
    if (Number(this.rating().rating) >= Number(this.rating().starCount)) {
      return 0;
    }
    return Number(this.rating().starCount) - Number(this.rating().rating);
  });

  @HostBinding('title') title = '';

  constructor() {
    effect(() => {
      if (this.rating().label?.length) {
        this.title = this.rating().label ?? '';
      } else if (this.rating().starCount) {
        this.title = $localize`${this.rating().rating} af ${this.rating().starCount} stjerner`;
      } else {
        this.title = $localize`${this.rating().rating} Point`;
      }
    });
  }
}
